export default {
    accepted: "[:attribute] mora biti prihvaćen.",
    after: "[:attribute] mora biti nakon [:after].",
    after_or_equal: "[:attribute] mora biti jednak ili nakon sutra.",
    alpha: "[:attribute] polje smije sadržavati samo abecedne znakove.",
    alpha_dash: "[:attribute] polje smije sadržavati samo alfanumeričke znakove, kao i crtice i donje crte.",
    alpha_num: "[:attribute] polje mora biti alfanumeričko.",
    before: "[:attribute] mora biti prije [:before].",
    before_or_equal: "[:attribute] mora biti jednako ili prije [:before_or_equal].",
    between: "[:attribute] polje mora biti između [:min] i [:max].",
    confirmed: "[:attribute] potvrda ne odgovara.",
    date: "[:attribute] nije pravilan format datuma.",
    def: "[:attribute] atribut ima greške.",
    different: "[:attribute] i [:different] moraju biti različiti.",
    digits: "[:attribute] moraju biti [:digits] znamenke.",
    email: "[:attribute] format je nepravilan.",
    in: "Odabrani [:attribute] je nepravilan.",
    integer: "[:attribute] mora biti cijeli broj.",
    max: {
        numeric: "[:attribute] ne smije biti veći od [:max].",
        string: "[:attribute] ne smije biti duži od [:max] znakova."
    },
    min: {
        numeric: "[:attribute] mora biti najmanje [:min].",
        string: "[:attribute] mora sadržavati najmanje [:min] znakova."
    },
    not_in: "Odabrani [:attribute] je nepravilan.",
    numeric: "[:attribute] mora biti broj.",
    present: "[:attribute] polje mora biti prisutno (ali može biti prazno).",
    regex: "[:attribute] format je nepravilan.",
    required: "Ovo polje je obavezno.",
    required_if: "[:attribute] polje je obavezno.",
    required_unless: "[:attribute] polje je obavezno kada [:other] nije [:value].",
    required_with: "[:attribute] polje je obavezno kada [:field] nije prazno.",
    required_with_all: "[:attribute] polje je obavezno kada [:fields] nisu prazna.",
    required_without: "[:attribute] polje je obavezno kada je [:field] prazno.",
    required_without_all: "[:attribute] polje je obavezno kada su [:fields] prazna.",
    same: "[:attribute] i [:same] moraju biti jednaki",
    size: {
        numeric: "[:attribute] mora biti [:size].",
        string: "[:attribute] mora imati [:size] znakova."
    },
    string: "[:attribute] mora biti niz.",
    url: "[:attribute] format je nepravilan."
};